export { EloVerifiedByVisaIcon } from './verified-by-visa-icon'
